import { Component } from '@theme/component';

class TwDishtempCalc extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    this.dishTempPrice = parseFloat(this.dataset.dishTempPrice) || 79.00;
    this.stripPrice = parseFloat(this.dataset.defaultStripPrice) || 1.00;
    this.testsDaily = parseInt(this.dataset.defaultTestsDaily) || 2;
    this.numLocations = parseInt(this.dataset.defaultLocations) || 1;

    this.initEventListeners();
    this.calculate();
  }

  initEventListeners() {
    const stripPriceInput = this.querySelector('[data-strip-price-input]');
    if (stripPriceInput) {
      stripPriceInput.addEventListener('input', (e) => {
        this.stripPrice = parseFloat(e.target.value) || 0;
        this.calculate();
      });
      stripPriceInput.addEventListener('blur', (e) => {
        const value = parseFloat(e.target.value) || 0;
        e.target.value = value.toFixed(2);
      });
      stripPriceInput.addEventListener('change', (e) => {
        const value = parseFloat(e.target.value) || 0;
        e.target.value = value.toFixed(2);
      });
    }

    const testsDailyInput = this.querySelector('[data-tests-daily-input]');
    if (testsDailyInput) {
      testsDailyInput.addEventListener('input', (e) => {
        this.testsDaily = parseInt(e.target.value) || 0;
        this.calculate();
      });
    }

    const numLocationsInput = this.querySelector('[data-num-locations-input]');
    if (numLocationsInput) {
      numLocationsInput.addEventListener('input', (e) => {
        this.numLocations = parseInt(e.target.value) || 0;
        this.calculate();
      });
    }
  }
  calculate() {
    const dailyCost = this.stripPrice * this.testsDaily * this.numLocations;
    const monthlyCost = dailyCost * 30;
    const yearlyCost = monthlyCost * 12;
    const dishtempCosts = this.dishTempPrice * this.numLocations;
    const annualSavings = yearlyCost - dishtempCosts;
    const dailySavings = annualSavings / 360;
    const breakEven = dailyCost > 0 ? Math.round(dishtempCosts / dailyCost) : 0;

    this.updateResults({
      dailyCost: dailyCost.toFixed(2),
      monthlyCost: monthlyCost.toFixed(2),
      yearlyCost: yearlyCost.toFixed(2),
      breakEven,
      annualSavings: annualSavings.toFixed(2),
      dailySavings: dailySavings.toFixed(2),
    });
  }

  updateResults(results) {
    // Daily cost
    const dailyCostEl = this.querySelector('[data-result-daily-cost]');
    if (dailyCostEl) {
      dailyCostEl.textContent = this.formatCurrency(results.dailyCost);
    }

    // Monthly cost
    const monthlyCostEl = this.querySelector('[data-result-monthly-cost]');
    if (monthlyCostEl) {
      monthlyCostEl.textContent = this.formatCurrency(results.monthlyCost);
    }

    // Annual cost
    const annualCostEl = this.querySelector('[data-result-annual-cost]');
    if (annualCostEl) {
      annualCostEl.textContent = this.formatCurrency(results.yearlyCost);
    }

    // Break-even
    const breakEvenEl = this.querySelector('[data-result-break-even]');
    if (breakEvenEl) {
      breakEvenEl.textContent = `${results.breakEven} days`;
    }

    // Annual savings
    const annualSavingsEl = this.querySelector('[data-result-annual-savings]');
    if (annualSavingsEl) {
      annualSavingsEl.textContent = this.formatCurrency(results.annualSavings);
    }

    // Daily savings
    const dailySavingsEl = this.querySelector('[data-result-daily-savings]');
    if (dailySavingsEl) {
      dailySavingsEl.textContent = this.formatCurrency(results.dailySavings);
    }
  }

  formatCurrency(value) {
    const num = parseFloat(value);
    const formatted = num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return `$${formatted}`;
  }
}

if (!customElements.get('tw-dishtemp-calc')) {
  customElements.define('tw-dishtemp-calc', TwDishtempCalc);
}
